import { render } from "./BulkSettlementReprocess.vue?vue&type=template&id=2dcfa5f6"
import script from "./BulkSettlementReprocess.vue?vue&type=script&lang=js"
export * from "./BulkSettlementReprocess.vue?vue&type=script&lang=js"

import "./BulkSettlementReprocess.vue?vue&type=style&index=0&id=2dcfa5f6&lang=css"

import exportComponent from "C:\\Users\\AbdullahiIsmail\\OneDrive - SWWIPE FINACIAL SERVICES\\Documents\\Automation-tool\\auto-portalV2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__